export type SelectItemProps = Omit<
  JSX.IntrinsicElements['option'],
  'placeholder'
>;

const SelectItem = ({ children, ...rest }: SelectItemProps) => {
  return <option {...rest}>{children}</option>;
};

export default SelectItem;
